import React, { useState, FormEvent, useEffect, useCallback } from 'react';

import { WebUiAlert } from '../components/alert';
import { WebUiButton } from '../components/button';
import { WebUiInput } from '../components/input';
import { useWebUiGlobalContext } from '../context/global/use-global-context';
import WebUiHeader from '../layout/header';

type WebUiLoginPageProps = {
  onSuccess: () => void;
};

export default function WebUiLoginPage({ onSuccess }: WebUiLoginPageProps) {
  const { login, currentUser } = useWebUiGlobalContext();

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(
    async (e: FormEvent) => {
      e.preventDefault();
      try {
        setLoading(true);
        const { success, message } = await login({ email: user, password });
        if (success) {
          onSuccess();
        } else {
          setError(message);
        }
      } catch (err) {
        const errorMessage = err as Error;
        setError(errorMessage.message);
      } finally {
        setLoading(false);
      }
    },
    [user, password, login, onSuccess],
  );

  useEffect(() => {
    if (currentUser) {
      onSuccess();
    }
  }, [currentUser, onSuccess]);

  return (
    <div className="min-h-screen w-full bg-webui-bg font-webui text-black">
      <WebUiHeader />
      <div className="mx-auto flex h-full min-h-[calc(100vh-80px)] items-center justify-center pt-20">
        <div className="border border-webui-border bg-webui-quinary">
          <div className="min-h-[220px] w-[430px] px-10 py-6">
            <h2 className="text-2xl font-bold">ROQSTAR</h2>
            <h3 className="text-lg font-bold">Managed Ethernet Switch</h3>
            <form className="mt-4" onSubmit={onSubmit}>
              <table className="text-base">
                <tbody>
                  <tr>
                    <td className="pr-3">User:</td>
                    <td>
                      <WebUiInput
                        value={user}
                        onChange={(e) => setUser(e.target.value)}
                        maxLength={30}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="pr-3">Password:</td>
                    <td>
                      <WebUiInput
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        maxLength={30}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td className="pt-2">
                      <WebUiButton
                        type="submit"
                        className="text-sm"
                        disabled={loading}
                      >
                        Login
                      </WebUiButton>
                    </td>
                  </tr>
                </tbody>
              </table>
              {error && (
                <WebUiAlert
                  type="error"
                  message={error}
                  className="mt-2"
                  size="sm"
                />
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
